import {css} from '@emotion/core'

export const container = css`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  margin: auto auto 150px auto;
`
